import { createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "subscriptionModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Subscription", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<p>Your free subscription plan has reached its limit for creating new projects. To continue enjoying the full range of our project creation features without interruption, we encourage you to upgrade to our Premium subscription plan.</p><div class=\"checklist my-4\"><p class=\"mb-2\"><strong>The Premium plan offers numerous benefits, including:</strong></p><ul><li class=\"d-flex\"><div class=\"icon-holder flex-shrink-0 mr-2 text-green\"><i class=\"fa fa-check\"></i></div><div class=\"flex-grow-1\">Unlimited project creation</div></li><li class=\"d-flex\"><div class=\"icon-holder flex-shrink-0 mr-2 text-green\"><i class=\"fa fa-check\"></i></div><div class=\"flex-grow-1\">Advanced collaboration tools</div></li><li class=\"d-flex\"><div class=\"icon-holder flex-shrink-0 mr-2 text-green\"><i class=\"fa fa-check\"></i></div><div class=\"flex-grow-1\">Priority customer support</div></li><li class=\"d-flex\"><div class=\"icon-holder flex-shrink-0 mr-2 text-green\"><i class=\"fa fa-check\"></i></div><div class=\"flex-grow-1\">Access to exclusive resources and updates</div></li></ul></div><p>To upgrade to the Premium plan, simply follow the upgrade prompts. If you have any questions or need assistance with the upgrade process, our support team is here to help.</p>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
              }, [
                _hoisted_7
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn my-3 w-100",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToUpgradeSubscription && _ctx.redirectToUpgradeSubscription(...args)))
              }, " Upgrade Now")
            ])
          ])
        ])
      ])
    ])
  ]))
}